module.exports = __webpack_public_path__ + "img/whiteexplainbig.cc4740cc.png";